import { useQuery } from "@tanstack/react-query";
import {
  getCustomerLoyalty,
  getLoyaltyConfig,
  getVoucherEligiblePackages,
} from "hooks/api/loyalty";

export const useLoyaltyConfig = () =>
  useQuery({
    queryKey: ["loyalty", "config"],
    queryFn: getLoyaltyConfig,
  });

export const useCustomerLoyalty = (customerId?: string) =>
  useQuery({
    queryKey: ["loyalty", "customer", customerId],
    queryFn: () => getCustomerLoyalty(customerId!),
    enabled: !!customerId,
  });

export const useVoucherEligiblePackages = (
  voucherId?: string,
  enabled = true
) =>
  useQuery({
    queryKey: ["loyalty", "voucher", voucherId, "eligible-packages"],
    queryFn: () => getVoucherEligiblePackages(voucherId!),
    enabled: enabled && !!voucherId,
  });
